import type { PaletteOptions } from '@mui/material';

// Brand colors from branding guide
export const brandColors = {
  primary: '#69936C',
  secondary: '#A1DBA6',
  theme: '#385E3A',
  background: '#ffffff',
};

// Module colors
export const moduleColors = {
  fulfill: '#ba3636',
  material: '#990000',
  availability: '#1A93AE',
  engage: '#7A936A',
  count: '#D8AD37',
  verify: '#684551',
  events: '#2B4570',
  restock: '#63b76b',
  produce: '#db6e14',
  reports: '#957117',
  sales: '#6296bc',
  retail: '#2e7d32',
  finish: '#00838f',
  crossCutting: '#6a6f73',
};

// Light theme palette
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: brandColors.primary,
    dark: brandColors.theme,
    light: brandColors.secondary,
    contrastText: '#ffffff',
  },
  secondary: {
    main: brandColors.secondary,
    dark: brandColors.primary,
    light: '#c8e9cd',
    contrastText: '#000000',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
  },
  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#388e3c',
  },
  background: {
    default: '#fafafa',
    paper: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
};

// Dark theme palette
export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: brandColors.secondary,
    dark: brandColors.primary,
    light: '#d4efd8',
    contrastText: '#000000',
  },
  secondary: {
    main: brandColors.primary,
    dark: brandColors.theme,
    light: brandColors.secondary,
    contrastText: '#ffffff',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
  },
  warning: {
    main: '#ffa726',
    light: '#ffb74d',
    dark: '#f57c00',
  },
  info: {
    main: '#29b6f6',
    light: '#4fc3f7',
    dark: '#0288d1',
  },
  success: {
    main: '#66bb6a',
    light: '#81c784',
    dark: '#43a047',
  },
  background: {
    default: '#121212',
    paper: '#1e1e1e',
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
};